import React from 'react';
import { Box, Divider } from '@mui/material';
import WorkshiftGlobalConfigPage from './WorkshiftGlobalConfigPage';
import WorkshiftLocalConfigPage from './WorkshiftLocalConfigPage';

export default function WorkshiftConfigPage() {
  return (
    <Box sx={{ p: 4, pt: 6 }}>
      
      {/* Globales */}
      <WorkshiftGlobalConfigPage />

      <Divider sx={{ my: 6 }} />

      {/* Locales */}
      <WorkshiftLocalConfigPage />
    </Box>
  );
}
